import {
  MODAL_401_CLEAR,
  MODAL_CLEAN_UP,
  MODAL_CLOSE,
  MODAL_OPEN,
  MODAL_WINDOW_POPSTATE,
} from '@app/store/actionTypes';
import { ModalAction } from '@app/store/modal/actions';
import { ModalType } from '@app/store/modal/types';

interface ModalRecord {
  modalType: ModalType;
  modalProps: Record<string, unknown>;
}

export type ModalState = ModalRecord[];

const initialState: ModalState = [];

export default function reducer(state: ModalState = initialState, action: ModalAction) {
  switch (action.type) {
    case MODAL_401_CLEAR:
    case MODAL_CLEAN_UP:
    case MODAL_WINDOW_POPSTATE:
      return initialState;
    case MODAL_CLOSE:
      return state.slice(0, state.length - 1);
    case MODAL_OPEN: {
      const { modalProps, modalType } = action.payload;
      return state.concat({ modalType, modalProps });
    }
    default:
      return state;
  }
}
